import React from "react";
import PropTypes from "prop-types";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { styled } from "@mui/material/styles";

import { ICONS, Icon } from "../../../components/Icons/Icon";

const StyledFormControlLabel = styled(FormControlLabel)(({ theme, classes }) => ({
  "&.MuiFormControlLabel-root": {
    marginRight: "auto",
    alignItems: "start",
    ...(classes?.root || {}), // Extend root styles
    "& .MuiFormControlLabel-label": {
      fontSize: "14px",
      ...(classes?.label || {}) // Extend label styles
    },
    "& .MuiCheckbox-root": {
      padding: "0 12px !important"
    }
  }
}));

export const CustomCheckbox = ({
  label,
  onSelect = () => {},
  classes: extendedClasses,
  ...rest
}) => {
  return (
    <StyledFormControlLabel
      classes={{ label: extendedClasses?.label, root: extendedClasses?.root }}
      control={
        <Checkbox
          onClick={onSelect}
          classes={{ root: extendedClasses?.checkbox }}
          icon={<Icon name={ICONS.uncheckedIcon} alt="checked icon" />}
          checkedIcon={<Icon name={ICONS.checkedIcon} alt="unchecked icon" />}
          sx={{
            py: 0,
            px: "12px"
          }}
          {...rest}
        />
      }
      label={label}
    />
  );
};

CustomCheckbox.propTypes = {
  label: PropTypes.string.isRequired,
  onSelect: PropTypes.func,
  classes: PropTypes.shape({
    label: PropTypes.object,
    root: PropTypes.object,
    checkbox: PropTypes.object
  })
};
